import { useQuery } from 'react-query';

import { axios } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

import { EventResponse } from '../types';
type UseBusinessOptions = {
  slugName?: string;
  token?: string;
  isRoomBooking?: boolean;
};
export const getAppointment = ({
  token,
  slugName,
  isRoomBooking,
}: UseBusinessOptions = {}): Promise<EventResponse> => {
  return axios.get(
    isRoomBooking
    ? `/business/${slugName}/booking/get/token/${token}`
      : `/business/${slugName}/appointment/get/token/${token}`,
    {
      params: {},
    }
  );
};

type QueryFnType = typeof getAppointment;
export const useAppointment = ({ token, isRoomBooking, slugName }: UseBusinessOptions = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['appointment'],
    queryFn: () => getAppointment({ token, isRoomBooking, slugName }),
  });
};
